import { useI18n } from 'vue-i18n';

export const useSetting = () => {
  const { locale } = useI18n({ useScope: 'global' });

  const fontSize = (size: 'ก+' | 'ก-') => {
    const body = document.querySelector<HTMLBodyElement>('BODY');
    body.style.fontSize = size === 'ก+' ? '1.0357rem' : '0.9357rem';
    const typographies: Array<[string, number, number]> = [
      ['H1', 2.7, 2.5],
      ['H2', 2.2, 2],
      ['H3', 1.95, 1.75],
      ['H4', 1.7, 1.5],
      ['H5', 1.45, 1.25],
      ['H6', 1.2, 1],
    ];
    typographies.map(typography => {
      [].slice.call(document.querySelectorAll<HTMLHeadingElement>(typography[0]))
        .map((m: HTMLHeadingElement) => m.style.fontSize = size === 'ก+'
          ? `${typography[1]}rem`
          : `${typography[2]}rem`);
    });
  };

  const language = (lang: 'EN' | 'TH') => {
    locale.value = lang.toUpperCase();
  };

  return { fontSize, language };
};
